<template>
  <div >
        <div class="container">
          <h1 class="title is-size-1">Circle Members</h1>          
        </div>

    <div class="container" v-for="member  in circleMembers" :circleID="circleID" :key="member.MemberID" >

    </div>
  </div>

</template>

<script>
import EventService from '@/services/EventService.js'; 

export default {
  name: 'circlelist',
  components: {
    
  },
 data() {
    return {
      circleMembers: [],


    };
  },

  computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },

        },

 mounted: {
    circleID: this.$route.params.circleID,
 },

  methods: {

    async getMembers() {
        await (EventService.getCircleMembersAll(this.circleID)
            ) 

      .then(
        (circleMembers => {
          this.$set(this, "circleMembers", circleMembers);
        }).bind(this)
      )
    }

  }

}
</script>
<style lang="scss" scoped>
  body {
    background: green;
  }
  .org-description {
    margin-top: 50px;
  }
</style>